import React, { useState } from "react";
// mui
import { Grid2, Skeleton } from "@mui/material";
//styling
import styles from "./SitesOverviewCard.module.scss";
// Icons
import PhpOutlinedIcon from "@mui/icons-material/PhpOutlined";
import { ReactComponent as SiteImg } from "../../../../../../GlobalAssets/svg/Blueprint12.svg";
import { ReactComponent as Staging } from "../../../../../../GlobalAssets/svg/Staging.svg";
import { ReactComponent as Production } from "../../../../../../GlobalAssets/svg/Production.svg";
import { ReactComponent as WordPress } from "../../../../../../GlobalAssets/svg/Wordpress.svg";
import { ReactComponent as PerformanceIcon } from "../../../../AdminAssets/svg/performance.svg";
import { ReactComponent as WafIcon } from "../../../../AdminAssets/svg/WafIcon.svg";
import { ReactComponent as StorageAddonIcon } from "../../../../AdminAssets/svg/Storage_plan.svg";
// Local import
import EnvironmentBox from "../../../../../../GlobalComponents/EnvironmentBox/EnvironmentBox";
import Storage from "../../../../AdminComponents/StorageComponent/Storage";
import { useNavigate } from "react-router-dom";
import { icons } from "../../../../../../Utils/roconConstants";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import FormPopup from "../../../../../../GlobalComponents/FormPopup/FormPopup";
import { Actions } from "../../../../../../redux/constants/actionTypes";
import { getStore } from "../../../../../../Utils/storeUtils";
import {
  ActivatePopup,
  blockIfSiteDeleting,
} from "../../../../../../Utils/activatePopup";
import { getRoleInOrg } from "../../../../../../Utils/organizations";
import AddonIcons from "../../../../../../GlobalComponents/AddonIcons/AddonIcons";
import { useSelector } from "react-redux";
import { useEmailId } from "../../../../../../Utils/utils";

export default function SitesOverviewCard(props) {
  const {
    name,
    domain,
    phpAdmin,
    wPAdmin,
    status,
    storage,
    bandwidth,
    visits,
    production,
    domainClick,
    image,
    siteId,
    orgId,
    selectedOrg,
    staging,
    addOns,
    selectedDomain,
    dedicatedHosting,
    deletionInProgress,
  } = props;

  const [popup, setPopup] = useState({
    popupState: false,
    popupType: "",
    popupTitle: "",
    popupSubtitle: "",
    popupSubtitle1: "",
    popupButton: false,
    popupCancel: false,
    popupButtonTitle: "",
    popupCancelTitle: "",
    popupButtonFunction: () => {},
    popupCancelFunction: () => {},
  });
  const [loading, setLoading] = useState(false);

  const emailId = useEmailId();
  let userDetails = useSelector((state) => state.users.userDetails?.theme);

  const navigate = useNavigate();

  const blockedByDeletion = () =>
    blockIfSiteDeleting({ siteId, deletionInProgress }, setPopup);

  const handleSiteClick = () => {
    if (blockedByDeletion()) {
      return;
    }
    if (status === "provision") {
      return;
    } else {
      getStore().dispatch({
        type: Actions.SET_SELECTED_DOMAIN,
        data: null,
      });
      navigate(`/account/${orgId}/${siteId}/site-details`);
    }
  };
  const featureIcons = icons(storage, bandwidth, visits, status);

  const deleteSiteAPI = () => {
    setLoading(true);
    getStore().dispatch({
      type: Actions.API_DELETE_SITE,
      data: {
        siteId: siteId,
      },
      meta: {
        onSuccess: () => {
          getStore().dispatch({
            type: Actions.API_SITE_OVERVIEW,
            data: { orgId: orgId },
          });
          getStore().dispatch({ type: Actions.API_GET_USER_NOTIFICATIONS });
          ActPopup("success-del-prod");
          setLoading(false);
        },
        onError: (error) => {
          const statusCode =
            error?.response?.status ||
            error?.status ||
            error?.data?.response?.status;

          if (statusCode === 504) {
            getStore().dispatch({
              type: Actions.API_SITE_OVERVIEW,
              data: { orgId: orgId },
            });
            getStore().dispatch({ type: Actions.API_GET_USER_NOTIFICATIONS });
            ActPopup("success-del-prod");
            setLoading(false);
            return;
          }

          setLoading(false);
          ActivatePopup("error-warn", setPopup);
          setPopup({ popupState: false });
        },
      },
    });
  };

  const getBackgroundColor = () => {
    if (staging) {
      return userDetails === "dark" ? "#141618" : "#f0f3f8";
    } else return userDetails === "dark" ? "#181a1c" : "#ffffff";
  };

  const handleEnvironmentClick = (env) => {
    if (blockedByDeletion()) {
      return;
    }
    if (env === "STAGING") {
      navigate(`/account/${orgId}/${siteId}/site-details?staging`);
    } else if (env === "LIVE") {
      navigate(`/account/${orgId}/${siteId}/site-details?live`);
    }
  };

  const phpAdminORwpAdmin = (portal) => {
    if (blockedByDeletion()) {
      return;
    }
    getStore().dispatch({
      type: Actions.API_AUTO_LOGIN,
      data: {
        portal: portal,
        stagingDomainId: selectedDomain,
      },
      meta: {
        onSuccess: (response) => {
          if (response) {
            window.open(response, "_blank");
          }
        },
        onError: (error) => {
          console.error("Auto login failed:", error);
        },
      },
    });
  };

  const ActPopup = (type) => {
    if (type === "success-del-prod") {
      setPopup({
        popupState: true,
        popupType: "success",
        popupTitle: "Production Environment Deleted Successfully",
        popupSubtitle: "Your production environment was successfully deleted.",
        popupCancel: false,
        popupButton: true,
        popupButtonTitle: "OK",
        popupButtonFunction: () => {
          setPopup({ popupState: false });
        },
      });
    }
  };

  return (
    <Grid2
      className={styles.SitesOverviewCardContainer}
      style={{
        background: `${getBackgroundColor()}`,
      }}
      onClick={() => {
        handleSiteClick();
      }}
    >
      <Grid2 className={styles.imageBox}>
        {status === "provision" ? (
          <Skeleton
            variant={"rectangular"}
            width={250}
            height={135}
            sx={{
              backgroundColor:
                userDetails === "dark" ? "#f5f5f5" : "rgba(0,0,0,0.11)",
            }}
          />
        ) : image ? (
          <img src={image} className={styles.uploadedImage} />
        ) : (
          <SiteImg className={styles.image} />
        )}
      </Grid2>
      <Grid2 className={styles.FlexBox}>
        <Grid2 className={styles.nameEnv}>
          <Grid2 className={styles.siteName}>{name}</Grid2>
          <Grid2
            className={styles.status}
            style={{
              color:
                status === true
                  ? "#27AE60"
                  : status === "provision"
                  ? "#D9B751"
                  : status === false
                  ? "#FF4444"
                  : "transparent",
            }}
          >
            {status === "provision"
              ? "Loading"
              : status === true
              ? "Available"
              : status === false
              ? "Site Down"
              : ""}
          </Grid2>

          {status !== "provision" && (
            <Grid2 container spacing={1}>
              {dedicatedHosting
                ? ""
                : addOns?.performanceSite === true && (
                    <Grid2 item>
                      <AddonIcons
                        icon={PerformanceIcon}
                        tooltipText="Performance Site"
                      />
                    </Grid2>
                  )}
              {addOns?.WAF === true && (
                <Grid2 item>
                  <AddonIcons icon={WafIcon} tooltipText="WAF" />
                </Grid2>
              )}
              {addOns?.storageGB > 0 && (
                <Grid2 item>
                  <AddonIcons
                    icon={StorageAddonIcon}
                    tooltipText={`Additional Storage: ${addOns.storageGB} GB`}
                  />
                </Grid2>
              )}
            </Grid2>
          )}

          <Grid2 className={styles.envContainer}>
            {status === "provision" && (
              <Grid2
                className={styles.delete}
                onClick={(e) => {
                  e.stopPropagation();
                  if (blockedByDeletion()) {
                    return;
                  }
                  if (orgId !== -1) {
                    if (
                      getRoleInOrg(emailId, selectedOrg) === "Owner" ||
                      getRoleInOrg(emailId, selectedOrg) === "Admin" ||
                      getRoleInOrg(emailId, selectedOrg) === "Super Admin"
                    ) {
                      ActivatePopup("delete-site", setPopup, deleteSiteAPI);
                    } else {
                      ActivatePopup("user-warn", setPopup);
                    }
                  } else ActivatePopup("delete-site", setPopup, deleteSiteAPI);
                }}
              >
                <DeleteOutlineOutlinedIcon className={styles.deleteIcon} />
              </Grid2>
            )}
            {!dedicatedHosting && (
              <>
                {staging === "STAGING" && (
                  <EnvironmentBox
                    Icon={Staging}
                    label="Staging"
                    shortLabel="Stag"
                    flexDirection="row"
                    width="120px"
                    border="0px"
                    status={status === "provision" ? true : false}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleEnvironmentClick("STAGING");
                    }}
                    userDetails={userDetails}
                  />
                )}
                {production === "LIVE" && (
                  <EnvironmentBox
                    Icon={Production}
                    label="Production"
                    shortLabel="Prod"
                    flexDirection="row"
                    width="120px"
                    status={status === "provision" ? true : false}
                    color={true}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleEnvironmentClick("LIVE");
                    }}
                    userDetails={userDetails}
                  />
                )}
              </>
            )}
          </Grid2>
        </Grid2>
        <Grid2 className={styles.emailFlexBox}>
          <Grid2
            className={
              status !== "provision" ? styles.siteEmail : styles.siteEmail1
            }
            onClick={(e) => {
              e.stopPropagation();
              if (blockedByDeletion()) {
                return;
              }
              if (status !== "provision") {
                domainClick();
              }
            }}
          >
            {domain}
          </Grid2>
          {!dedicatedHosting && (
            <Grid2 className={styles.Admin}>
              <Grid2 className={styles.adminFlexBox1}>
                <PhpOutlinedIcon className={styles.iconColor} />
                <Grid2
                  className={
                    status !== "provision" ? styles.admin : styles.admin1
                  }
                  onClick={(e) => {
                    e.stopPropagation();
                    if (status !== "provision") {
                      phpAdminORwpAdmin("php_my_admin");
                    }
                  }}
                >
                  {phpAdmin}
                </Grid2>
              </Grid2>
              <Grid2 className={styles.adminFlexBox1}>
                <WordPress className={styles.iconColor} />
                <Grid2
                  className={
                    status !== "provision" ? styles.admin : styles.admin1
                  }
                  onClick={(e) => {
                    e.stopPropagation();
                    if (status !== "provision") {
                      phpAdminORwpAdmin("wp_admin");
                    }
                  }}
                >
                  {wPAdmin}
                </Grid2>
              </Grid2>
            </Grid2>
          )}
        </Grid2>
        <Grid2 className={styles.StorageFlexBox}>
          {featureIcons.map((features, index) => {
            return (
              <Storage
                key={index}
                unit={features.unit}
                use={features.use}
                type={features.type}
                icon={features.icon}
                status={features.status}
                staging={staging}
                userDetails={userDetails}
              />
            );
          })}
        </Grid2>
      </Grid2>

      {/* The card root is clickable, so keep popup clicks from bubbling back
          into handleSiteClick and re-opening what was just dismissed. */}
      <section onClick={(e) => e.stopPropagation()}>
        <FormPopup
          trigger={popup.popupState}
          setTrigger={setPopup}
          type={popup.popupType}
          title={popup.popupTitle}
          subtitle={popup.popupSubtitle}
          button={popup.popupButton}
          cancel={popup.popupCancel}
          buttonTitle={popup.popupButtonTitle}
          buttonFunction={popup.popupButtonFunction}
          loading={loading}
          cancelTitle={popup.popupCancelTitle}
          cancelFunction={popup.popupCancelFunction}
        />
      </section>
    </Grid2>
  );
}
